import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "styled-components";
import { createStore, combineReducers, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import createSagaMiddleware from "redux-saga";
import logger from "redux-logger";
import { Route } from "react-router";
import createHistory from "history/createBrowserHistory";
import {
  ConnectedRouter,
  routerReducer,
  routerMiddleware
} from "react-router-redux";
import search from "./reducers/search";
import { rootSaga } from "./sagas/search";
import "./index.css";

import SearchContainer from "./containers/SearchContainer";
import MapContainer from "./containers/MapContainer";

import theme from "./theme/";

const history = createHistory();
const sagaMiddleware = createSagaMiddleware();
const middleware = [
  routerMiddleware(history),
  sagaMiddleware,
  process.env.NODE_ENV === "development" && logger
].filter(Boolean);

const store = createStore(
  combineReducers({
    search,
    router: routerReducer
  }),
  applyMiddleware(...middleware)
);

sagaMiddleware.run(rootSaga);

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <div>
          <Route exact path="/" component={SearchContainer} />
          <Route path="/map/:lat/:lng/:date" component={MapContainer} />
        </div>
      </ConnectedRouter>
    </Provider>
  </ThemeProvider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js